export { default } from './TabletView';
